module.exports = __webpack_public_path__ + "img/parker-westport-hero.fe940637.webp";